;(function (angular, _, taTools) {
  'use strict'
  angular
    .module('kilo.common.directives')
    .directive('emailEdit', EmailEditorDirective)

  EmailController.$inject = ['EmailService', '$scope']
  function EmailController(EmailService, $scope) {
    var self = this

    _.extend(self, {
      toolBar: [
        ['h1', 'h2', 'h6', 'p', 'quote'],
        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent']
      ],
      cursorPosition: 0,
      isLoaded: false,
      showSubject: true,
      handleKeydown: handleKeydown,
      handleInput: handleInput,
      fileDropHandler: fileDropHandler
    })
    self.$onInit = function () {
      setTaTools()
    }

    function setTaTools () {
      taTools.bold = { ...taTools.bold, iconclass: 'mdi mdi-format-bold', tooltiptext: 'Gras' }
      taTools.italics = { ...taTools.italics, iconclass: 'mdi mdi-format-italic', tooltiptext: 'Italique' }
      taTools.quote = { ...taTools.quote, iconclass: 'mdi mdi-format-quote-close', tooltiptuseext: 'Citation' }
      taTools.underline = { ...taTools.underline, iconclass: 'mdi mdi-format-underline', tooltiptext: 'Souligner' }
      taTools.ul = { ...taTools.ul, iconclass: 'mdi mdi-format-list-bulleted', tooltiptext: 'Liste non ordonnée' }
      taTools.ol = { ...taTools.ol, iconclass: 'mdi mdi-format-list-bulleted-type', tooltiptext: 'Liste ordonnée' }
      taTools.undo = { ...taTools.undo, iconclass: 'mdi mdi-undo', tooltiptext: 'Annuler' }
      taTools.redo = { ...taTools.redo, iconclass: 'mdi mdi-redo', tooltiptext: 'Refaire' }
      taTools.justifyLeft.iconclass = 'mdi mdi-format-align-left'
      taTools.justifyRight.iconclass = 'mdi mdi-format-align-right'
      taTools.justifyCenter.iconclass = 'mdi mdi-format-align-center'
      taTools.justifyFull.iconclass = 'mdi mdi-format-align-justify'
      taTools.clear.iconclass = 'mdi mdi-cancel'
      taTools.strikeThrough.iconclass = 'mdi mdi-format-strikethrough-variant'
      taTools.outdent.iconclass = 'mdi mdi-format-indent-decrease'
      taTools.indent.iconclass = 'mdi mdi-format-indent-increase'
      taTools.insertImage.iconclass = 'mdi mdi-image'
      if (self.image) {
        self.toolBar[2].push('insertImage')
        self.showSubject = false
      }
      self.isLoaded = true
    }

    function fileDropHandler(file, insertAction) {
      if (self.image) {
        if (!file || !file.type.match(/^image\//)) {
          alert('Seules les images sont acceptées')
          return
        }
        if (file.size > 500000) {
          alert('La taille du fichier ne peut pas dépasser 0.5MB')
          return
        }
        // Upload l'image
        EmailService.uploadAttachment(file)
          .then((response) => {
            if (response && response.data.length > 0) {
              if (!self.attachments) {
                self.attachments = []
              }
              self.attachments.push(response.data[0]._id)
            }
          })
          .catch((error) => {
            alert('Erreur lors de l\'upload de l\'image')
          })
      }
    }

    function handleKeydown (event) {
      if (event.keyCode === 8) {
        event.preventDefault()
        var selection = window.getSelection()
        var range = selection.getRangeAt(0)
        self.lastSelection = {
          startContainer: range.startContainer,
          startOffset: range.startOffset,
          endContainer: range.endContainer,
          endOffset: range.endOffset
        }
        if (!selection.isCollapsed) {
          document.execCommand('delete', false)
          return
        }

        var element = event.target
        var caretPos = getCaretCharacterOffsetWithin(element)

        if (caretPos > 0) {
          document.execCommand('delete', false)
        }
      }
    }

    function handleInput(event) {
      var element = event.target;
      self.cursorPosition = getCaretCharacterOffsetWithin(element);

      if (self.model !== element.innerHTML) {
        safeApply(() => {
          self.model = element.innerHTML
        })
      }
    }

    function getCaretCharacterOffsetWithin(element) {
      var caretOffset = 0
      var doc = element.ownerDocument || element.document
      var win = doc.defaultView || doc.parentWindow
      var sel = win.getSelection()

      if (sel.rangeCount > 0) {
        var range = sel.getRangeAt(0)
        var preCaretRange = range.cloneRange()
        preCaretRange.selectNodeContents(element)
        preCaretRange.setEnd(range.endContainer, range.endOffset)
        caretOffset = preCaretRange.toString().length
      }
      return caretOffset
    }

    function safeApply (fn) {
      var phase = $scope.$root.$$phase
      if (phase === '$apply' || phase === '$digest') {
        if (fn && typeof fn === 'function') {
          fn()
        }
      } else {
        $scope.$apply(fn)
      }
    }
  }

  function EmailEditorDirective () {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/email/email.directive.html',
      controllerAs: '$ctrl',
      controller: EmailController,
      bindToController: {
        model: '=',
        subject: '=',
        image: '=?',
        attachments: '=?'
      },
      scope: {
        model: '=',
        subject: '=',
        image: '=?',
        attachments: '=?'
      },
    }
  }
})(window.angular, window._, window.taTools)
